// extracted by mini-css-extract-plugin
export default {"errorBackground":"jQ7kEWAFVtgHPVioTXmE","errorItem":"akiPiun6hnykrv_Qf4lU"};